export default function BrushCropIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" id="Capa_1" viewBox="0 0 700 700">
        <path d="M374.54,433.7l-65.25,38.09c-8.26-22.86-26.98-40.69-50.39-47.69l36.57-65.78s264.83-246.47,290.57-220.7c25.75,25.75-211.5,296.08-211.5,296.08Z"/>
        <path d="M283.84,515.36h.02c-16.52,43-67.51,63.26-116.64,37.57-80.44-42.06-49.27-180.67-49.27-180.67,0,16.42,41.05,73.9,94.57,71.89,14.99-.57,30.36-4.01,39.69-.39,28.47,11.03,42.6,43.11,31.64,71.6Z"/>
      </svg>
    </>
  );
}